import { offsetTons } from '../../AdditionalSales/sales/LeadCarbonOffsetSale/offsetTons'
import { defineSaleProgress, isSaleSigned, isSaleStarted, type ProgressSaleData } from '../saleProgress'

interface CarbonOffsetData extends ProgressSaleData {
  offsetId?: number | string | null
  productId?: number | string | null
  presentationAccepted?: boolean
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export default defineSaleProgress<CarbonOffsetData>({
  kind: 'sale',
  cascade: true,
  pandaDoc: true,
  steps: [
    { key: 'accord', label: `${TIMELINE}accord`, done: data => !!data.presentationAccepted },
    { key: 'sms_code', label: `${TIMELINE}sms_code`, done: isSaleStarted },
    { key: 'signature', label: `${TIMELINE}signature`, done: isSaleSigned },
  ],
  formulaId: data => data.offsetId ?? data.productId,
  panelValues: formula => ({ tons: offsetTons(formula) }),
})
